import {Permission} from '../../core/models/permission.model';
import { Injectable } from '@angular/core';

@Injectable()
export class Utils {
  public extractNameEmail(email) {
    email = email.split('@');
    return email[0];
  }

  public extractUserName(user: any) {
    if (user.body) {
      return `${user.body.firstName} ${user.body.lastName}`;
    }
    return `${user.firstName} ${user.lastName}`;
  }

  public deepCopy<T>(object: T): T {
    return JSON.parse(JSON.stringify(object));
  }
}
